import { recipe } from "@vanilla-extract/recipes";

import { theme } from "../../theme/css/theme.css";
import { transition } from "../../utils/transition";

export const positionerStyle = recipe({
  base: {
    position: "absolute",
    width: 0,
    height: 0,
    userSelect: "none",
    pointerEvents: "none",
    transition: transition("opacity"),
    ":empty": {
      display: "none",
    },
  },
  variants: {
    placement: {
      top: { transform: "translate(-50%, -100%)" },
      topLeft: { transform: "translate(-100%, -100%)" },
      topRight: { transform: "translate(0, -100%)" },
      bottom: { transform: "translate(-50%, 0)" },
      bottomLeft: { transform: "translate(-100%, 0)" },
      bottomRight: { transform: "translate(0, 0)" },
      left: { transform: "translate(-100%, -50%)" },
      leftTop: { transform: "translate(-100%, -100%)" },
      right: { transform: "translate(0, -50%)" },
      rightTop: { transform: "translate(0, -100%)" },
      center: { transform: "translate(-50%, -50%)" },
    },
    debug: {
      true: {
        ":before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "5px",
          height: "5px",
          background: "red",
          transform: "translate(-50%, -50%)",
          borderRadius: "50%",
        },
      },
      false: {
        ":empty": {
          display: "none",
        },
      },
    },
  },
});

export const contentRepositionStyle = recipe({
  base: {
    position: "absolute",
    pointerEvents: "none",
  },
  variants: {
    offset: {
      default: {
        vars: { "--offset": theme.spacings.xs },
      },
      s: {
        vars: { "--offset": theme.spacings.s },
      },
      m: {
        vars: { "--offset": theme.spacings.m },
      },
    },
    placement: {
      left: {
        transform: `translate(calc(-100% - var(--offset)), -50%)`,
      },
      leftTop: {
        transform: `translate(calc(-100% - var(--offset)), 0)`,
      },
      right: {
        transform: `translate(var(--offset), -50%)`,
      },
      rightTop: {
        transform: `translate(var(--offset), -100%)`,
      },
      top: {
        transform: `translate(-50%, calc(-100% - var(--offset)))`,
      },
      topLeft: {
        transform: `translate(-100%, calc(-100% - var(--offset)))`,
      },
      topRight: {
        transform: `translate(0, calc(-100% - var(--offset)))`,
      },
      bottom: {
        transform: `translate(-50%, var(--offset))`,
      },
      bottomLeft: {
        transform: `translate(-100%, var(--offset))`,
      },
      bottomRight: {
        transform: `translate(0, var(--offset))`,
      },
      center: {
        transform: `translate(-50%, -50%)`,
      },
    },
  },
  defaultVariants: {
    offset: "default",
  },
});
